import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.45886 12.5104C3.80713 15.8642 7.37902 18.34 11.6664 18.3258C15.9538 18.3116 19.5093 15.8122 20.8353 12.4496C19.487 9.09579 15.9151 6.61998 11.6277 6.63416C7.34034 6.64835 3.78491 9.14774 2.45886 12.5104ZM22.2548 12.4449C20.8749 16.6066 16.6629 19.6426 11.6708 19.6591C6.67881 19.6756 2.44678 16.6676 1.03938 12.5151C2.41927 8.35332 6.63131 5.31736 11.6233 5.30084C16.6154 5.28432 20.8474 8.29236 22.2548 12.4449ZM16.2481 12.4648C16.2565 15.0035 14.2053 17.0683 11.6666 17.0767C9.12796 17.0851 7.06314 15.0339 7.05474 12.4953C7.04634 9.95658 9.09754 7.89176 11.6362 7.88336C14.1749 7.87496 16.2397 9.92616 16.2481 12.4648ZM14.9148 12.4693C14.9208 14.2716 13.4645 15.7375 11.6622 15.7434C9.85992 15.7494 8.39403 14.2932 8.38806 12.4909C8.3821 10.6885 9.83833 9.22264 11.6406 9.21668C13.443 9.21072 14.9089 10.6669 14.9148 12.4693Z"
	})]
});
const ForwardRef = forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
